import { Injectable } from '@angular/core';
import { BaseSortService } from 'src/services/general/base.sort.service';
import { StorageKey } from 'src/models/general/storage.key.enum';
import { SortValue } from 'src/models/general/sort.model';

@Injectable({
	providedIn: 'root'
})
export class OrderSortService extends BaseSortService {
	constructor() {
		super();
		this.init(StorageKey.orderSort, this.createSortDefaultValues());
	}

	private createSortDefaultValues(): SortValue {
		return {
			active: 'datum',
			direction: 'desc'
		};
	}
}
